import { usePersistedDataStore } from '../../store';


// THis is so stupid, the negotiation object and advanced settings should be one and the same, we shouldn't neeld this.

/**
 * When advanced settings are saved, keep the in-memory negotiation object aligned
 * so downstream code (autosave, KNN, etc.) reads the same filters without a full re-fetch.
 */
export function mergeNegotiationObjWithAdvancedSettings(saved) {
  const prev = usePersistedDataStore.getState().negotiationObj;
  if (!prev || !saved || typeof saved !== 'object') return;

  const patch = {
    Stage: saved.stage,
    manualReview: saved.autosave === false,
    showSettledCases: Array.isArray(saved.defaultRunTypes) && saved.defaultRunTypes.includes('settled'),
    scarOnly: !!saved.defaultRunTypes?.includes('scarFiled'),
    unreviewed_flag: saved.unreviewed_flag ?? 'False',
    reviewedCasesFlag: !!saved.defaultRunTypes?.includes('reviewed'),
    mlsCompsOnly: !!saved.compFilters?.includes('mlsOnly'),
    allowConditionIssues: saved.compFilters?.includes('allowConditionIssues') || true,
    manualReviewOverride: saved.manualReviewOverride ?? 0,
    expandComps: saved.expandComps === true,
    compLimit:
      saved.compLimit === '' || saved.compLimit === undefined || saved.compLimit === null
        ? null
        : saved.compLimit,
    skipRerunOnInventoryUpdate: saved.skipRerunOnInventoryUpdate === true,
    HighTaxRun: saved.highTaxRun === true,
    HighTaxCount:
      saved.highTaxRun === true
        ? (saved.highTaxCount == null || saved.highTaxCount === '' ? null : saved.highTaxCount)
        : null,
    timeAdjustmentMonths: (() => {
      if (saved.timeAdjustmentMonths != null && saved.timeAdjustmentMonths !== '') {
        const n = Math.floor(Number(saved.timeAdjustmentMonths));
        if (Number.isFinite(n) && n >= 1) return n;
      }
      return saved.useTimeAdjustedPrice === true ? 3 : null;
    })(),
  };

  const passthrough = [
    'squareFeetFilter',
    'acreageFilter',
    'grossAdjPctFilter',
    'netAdjPctFilter',
    'compFilters',
    'dateRange',
    'dateRangeType',
    'beforePreset',
    'afterPreset',
    'evalDate',
    'earliestSaleIntDate',
    'latestSaleIntDate',
  ];
  for (const key of passthrough) {
    if (saved[key] !== undefined) patch[key] = saved[key];
  }

  const next = { ...prev, ...patch };
  delete next.useTimeAdjustedPrice;
  usePersistedDataStore.getState().setNegotiationObj(next);
}
